import { render, staticRenderFns } from "./QScoreCardHqBirthdays.vue?vue&type=template&id=2441c142&scoped=true&"
import script from "./QScoreCardHqBirthdays.vue?vue&type=script&lang=js&"
export * from "./QScoreCardHqBirthdays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2441c142",
  null
  
)

export default component.exports